export default __webpack_public_path__ + "static/media/wi-day-sunny.39bfb0e8.svg";